/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router'
import { MapShareDrawer as MapShare } from 'ui-components'
import { getWorkspaceLink } from 'utils'
import { DuplicateMapButton as Duplicate } from '~map-preview/App/Tools/DuplicateMapButton'
import { EmbedButton } from '~map-preview/App/Tools/EmbedButton'
import { InfographicButton } from '~map-preview/App/Tools/InfographicButton'
import { useIsShareAllowed } from '~map-preview/hooks/useIsShareAllowed'
import { useIsWorkspaceOwner } from '~map-preview/hooks/useIsWorkspaceOwner'
import { useMap } from '~map-preview/states/map'
import { EmailShare } from './EmailShare'
import { LinkShare } from './LinkShare'
import { PublicShare } from './PublicShare'

function MapShareDrawer() {
  const isOwner = useIsWorkspaceOwner()
  const isShareAllowed = useIsShareAllowed()
  const router = useRouter()
  const map = useMap()

  const handleManageAccess = () => {
    router.push(
      getWorkspaceLink({
        workspaceId: map.workspace.id,
        workspaceName: map.workspace.name,
        tab: 'members'
      })
    )
  }

  if (!isShareAllowed) return null

  return (
    <MapShare
      isPublic={map?.isPublic}
      isOwner={isOwner}
      onManageAccess={handleManageAccess}
      slots={{
        EmailShare,
        PublicShare,
        LinkShare,
        Footer: {
          Duplicate,
          InfographicButton,
          EmbedButton
        }
      }}
    />
  )
}

export { MapShareDrawer }
